import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch item details from a specific branch of a restaurant
 * @param {number} restaurantId - The restaurant ID
 * @param {number} branchId - The branch ID
 * @param {number} itemId - The item ID
 * @param {string} language - The language parameter (e.g., "en")
 * @param {number} currencyId - The currency ID
 * @returns {Promise<Object>} - Response data from the API
 */
export const getItemDetails = async (restaurantId, branchId, itemId) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.RESTAURANT}/${restaurantId}/branch/${branchId}/item/${itemId}?language=en&currency_id=3`
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
